export const app = {
    title: 'Form Generateur NL',
    modals:{
        session:{
            title:'Wil je de gegevens van je vorige sessie bewaren',
            confirm:'Ja',
            cancel:'Neen',
        },
        error:{
            title:'Er is een fout opgetreden. Probeer het alstublieft nog eens',
            confirm:'Probeer opnieuw',
        }
    }
}
